export default {
    jobId: Number,
    userId: Number,
    recipientId: Number,
    view: String
}
